@if (loading) {
  <motn-spinner></motn-spinner>
}

@if (!loading) {
  @if (table$ | async; as table) {
    <motn-sort-table
      [hidden]="table.rows.length === 0"
      [table$]="table$"
      (renderedRows$)="tableRowsRendered($event)"
      [bulkSelectCapabilities]="{cloneTiles: true, deleteTiles: true, downloadConfiguration: true}"
    ></motn-sort-table>

    @if (table.rows.length === 0) {
      <div class="empty-state-container">
        <i class="empty-state-icon fa-regular fa-magnifying-glass"></i>
        <p class="empty-state-text">{{ searchTerm || filters ? 'No tiles match your search' : 'No tiles found' }}</p>
      </div>
    }
  }
}

@if (editingTile) {
  <motn-tile-editor
    [tileId]="editingTile"
    (closed$)="editingTile = null"
    (deleted$)="deletedTile($event)"
    (saved$)="onTileSaved()"
  ></motn-tile-editor>
}

@if (schedulingTile) {
  <motn-schedules-viewer
    [tile]="schedulingTile"
    (clickedOutside$)="schedulingTile = null"
  ></motn-schedules-viewer>
}
